import { render, staticRenderFns } from "./PostLikes.vue?vue&type=template&id=34f9e779&scoped=true"
import script from "./PostLikes.vue?vue&type=script&lang=js"
export * from "./PostLikes.vue?vue&type=script&lang=js"
import style0 from "./PostLikes.vue?vue&type=style&index=0&id=34f9e779&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f9e779",
  null
  
)

export default component.exports